// frontend/src/components/mcbim/IfcClassesMenu.tsx
import React from "react";
import { Button, Menu, Checkbox, Box, Text } from "@mantine/core";
import { FiChevronDown } from "react-icons/fi";
import { MdViewModule } from "react-icons/md";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { IfcClassesEnum, IfcClassesTranslations } from "../../enums";
import { setIfcClassesToDisplayInRedux } from "../designSlice";

const IFCCLASSES_TO_TOGGLE: IfcClassesEnum[] = [
  IfcClassesEnum.IFCFURNITURE,
  IfcClassesEnum.IFCCOLUMN,
];

export const IfcClassesMenu: React.FC = () => {
  const dispatch = useAppDispatch();
  const ifcClassesToDisplay = useAppSelector((s) => s.design.ifcClassesToDisplay);

  const isActive = (cls: IfcClassesEnum) => {
    return !!ifcClassesToDisplay?.[cls];
  };

  const toggleIfcClass = (cls: IfcClassesEnum) => {
    dispatch(setIfcClassesToDisplayInRedux(cls));
  };

  const anyActive = IFCCLASSES_TO_TOGGLE.some((c) => isActive(c));
  const allSelected = IFCCLASSES_TO_TOGGLE.every((c) => isActive(c));

  const handleToggleAll = () => {
    if (allSelected) {
      // Skjul alle → gör alla false (toggle bara de som är true)
      IFCCLASSES_TO_TOGGLE.forEach((cls) => {
        if (isActive(cls)) {
          dispatch(setIfcClassesToDisplayInRedux(cls));
        }
      });
    } else {
      // Vis alle → gör alla true (toggle bara de som är false)
      IFCCLASSES_TO_TOGGLE.forEach((cls) => {
        if (!isActive(cls)) {
          dispatch(setIfcClassesToDisplayInRedux(cls));
        }
      });
    }
  };

  return (
    <Menu withinPortal position="bottom-start" shadow="md" closeOnItemClick={false}>
      <Menu.Target>
        <Button
          size="sm"
          variant={anyActive ? "light" : "subtle"}
          leftSection={<MdViewModule size={16} />}
          rightSection={<FiChevronDown size={14} />}
        >
          Objekter
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Box px="sm" py={6}>
          <Text size="xs" fw={600} c="dimmed">
            IFC-objekter
          </Text>
        </Box>

        {/* Vis alle / skjul alle */}
        <Menu.Item closeMenuOnClick={false} onClick={handleToggleAll}>
          <Text size="sm">{allSelected ? "Skjul alle" : "Vis alle"}</Text>
        </Menu.Item>

        <Menu.Divider />

        {/* Checkboxene – egen container så meny ikke lukkes */}
        <Box px="xs" pb="xs">
          {IFCCLASSES_TO_TOGGLE.map((cls) => (
            <Box
              key={cls}
              py={4}
              onMouseDown={(e) => e.preventDefault()} // hindrer Menu fra å lukkes
            >
              <Checkbox
                checked={isActive(cls)}
                onChange={() => toggleIfcClass(cls)}
                label={IfcClassesTranslations[cls]}
              />
            </Box>
          ))}
        </Box>
      </Menu.Dropdown>
    </Menu>
  );
};
